<template>
    <v-card v-bind="$attrs" class="pa-4 d-flex justify-space-between" outlined elevation="5" rounded="lg">
        <div class="pa-6 d-flex flex-column row mr-auto">
            <div class="headline">Linked Account</div>
            <div v-if="value && value.email" class="pt-3">
                <span class="pr-4">
                    <v-icon :color="value.completed ? 'green' : 'gray'">{{
                        value.completed ? mdiProgressCheck : mdiProgressAlert
                    }}</v-icon></span
                >
                {{ value.email }}
            </div>
            <div v-if="value && value.email" class="pt-1">
                Started: {{ new Date(value.createdAt).toLocaleString() }}
            </div>
            <div v-if="value.verifiedAt" class="pt-1">
                Completed: {{ new Date(value.verifiedAt).toLocaleString() }}
            </div>
            <div v-if="!value || !value.email" class="caption pt-1"> Click the edit icon to get started. </div>
        </div>
        <div>
            <v-icon v-if="edit && !value.verifiedAt" color="primary" @click="$emit('edit')">
                {{ mdiPencil }}
            </v-icon>
        </div>
    </v-card>
</template>

<script>
import { mdiProgressCheck, mdiProgressAlert, mdiPencil } from '@mdi/js'

export default {
    name: 'AccountLinkedAccount',
    inheritAttrs: false,
    props: {
        value: {
            type: Object,
            required: true,
            default() {
                return {}
            }
        },
        edit: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            mdiProgressAlert,
            mdiProgressCheck,
            mdiPencil
        }
    }
}
</script>
